<template lang="pug" src="./html/HalfMarathonFaceRecognition-Body.pug"></template>

<script>
  import ArticleItemBase from './ArticleItemBase'

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setupVideo('267007192', 'https://player.youku.com/embed/XNDAxNDU2NjI4NA==')
    }
  }
</script>

<style scoped>
    a {
        color: #7e7a84;
    }
    .img .purple {
        display: block;
        margin: 1em 0;
        padding: 0.1em 0;
        background: #521b92;
    }
    .img .purple img {
        margin: 1em 0;
    }
    .video {
        height: 125vw;
        margin-bottom: 0;
    }
    .video .loading {
        line-height: 125vw
    }
    .my-run {
        text-align: center;
        background: #1A7254;
        color: #FFFFFF;
        padding-top: 1em;
        margin-top: 2em;
        padding-bottom: 0.9em;
    }
</style>
